angular.module('bl.skipstep').directive('blSkipStep', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        controller: skipStep
    };
});

function skipStep($scope) {
    $scope.skipThisStep();
    return $scope.decideNextPage();
}


// WEBPACK FOOTER //
// ../src/public/javascripts/skip-step-function/skip_step.directive.js